import PopupGroupConstants from './PopupGroupConstants';

const uuidV4 = require('uuid/v4');

export const createGroup = (pageIndex, type) => (
  dispatch =>
    dispatch({
      type: PopupGroupConstants.POPUP_GROUP_CREATE,
      groupId: uuidV4(),
      data: {
        label: '',
        fieldIds: [],
        pageIndex,
        type,
        timestamp: Date.now(),
      },
    })
);

export const updateGroupPopupQuestion = (groupId, question) => (
  (dispatch) => {
    dispatch({
      type: PopupGroupConstants.POPUP_GROUP_QUESTION_UPDATE,
      groupId,
      question,
    });
  }
);

export const addToGroup = (groupId, id) => (
  (dispatch) => {
    dispatch({
      type: PopupGroupConstants.POPUP_GROUP_POPUP_ADD,
      groupId,
      id,
    });
  }
);

export const setActiveGroup = groupId => (
  (dispatch) => {
    dispatch({
      type: PopupGroupConstants.POPUP_GROUP_ACTIVE_SET,
      groupId,
    });
  }
);

export const beginEditingGroup = () => (
  (dispatch) => {
    dispatch({
      type: PopupGroupConstants.POPUP_GROUP_EDIT_GROUP_START,
    });
  }
);

export const endEditingGroup = () => (
  (dispatch) => {
    dispatch({
      type: PopupGroupConstants.POPUP_GROUP_EDIT_GROUP_END,
    });
  }
);

export const clearActiveGroupPopup = () => (
  (dispatch) => {
    dispatch({
      type: PopupGroupConstants.POPUP_GROUP_ACTIVE_CLEAR,
    });
  }
);

export const removeFieldFromGroup = (groupId, popupId) => (
  (dispatch) => {
    dispatch({
      type: PopupGroupConstants.POPUP_GROUP_POPUP_REMOVE,
      groupId,
      popupId,
    });
  }
);



// WEBPACK FOOTER //
// ./src-react/PopupGroup/PopupGroupActions.jsx